<template>
    <div>
        <div class="entry">
            <div class="entry-item" v-for="item in entry" v-bind:key="item.id">
                <img :src="item.imageUrl" @click="gotoDetail(item.link)"/>
            </div>
        </div>
        <div class="index-line"></div>
    </div>
</template>

<script>
export default {
    props:{
        entry:Array
    },
    methods:{
         gotoDetail(url){
            window.open(url);
        }
    }
}
</script>

<style scoped>
.entry{
    height: 80px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
}
.entry-item{
    width: 28%;
}
.entry-item img{
    cursor: pointer;
    height: 24px;
}
.entry-item img:hover{
    filter: brightness(120%)
}
.index-line{
    width: 100%;
    height: 6px;
}
</style>


// WEBPACK FOOTER //
// src/components/MobileEntry.vue